import styled from 'styled-components';
import { pxToRem } from '@quiqupltd/qu-react-sdk/lib/utils/styles';
import { media } from '@quiqupltd/qu-react-sdk/lib/styles/mixins/media';
import QuIcon from '@quiqupltd/qu-react-sdk/lib/components/qu-icon';

export const Container = styled.div`
  padding: 0 24px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  flex-grow: 1;

  padding: 0 16px 24px;

  ${media.up('phone')`
    padding: 0 48px 36px;
  `};
`;

export const LottieContainer = styled.div`
  padding-top: 24px;

  & > div {
    margin: -120px !important;
  }
`;

export const Header = styled.div`
  font-size: ${pxToRem(28)};
  font-weight: 300;
  color: ${props => props.theme.cornFlower500};
  text-align: center;
`;

export const Content = styled.div`
  font-size: ${pxToRem(16)};
  font-weight: 300;
  color: ${props => props.theme.grey};
  max-width: 312px;
  margin-top: 4px;
  text-align: center;
`;

export const Icon = styled(QuIcon)`
  position: absolute;
  right: 24px;
  top: 48px;
`;

export const DriverContainer = styled.div`
  width: 100%;
  margin: 40px 0;
  border-top: 1px solid ${props => props.theme.greyLight};
`;



// WEBPACK FOOTER //
// ./src/app/order-card/arrived/body/styles.js